import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, Tooltip } from '@mui/material';
import { TableCellStickyColumn } from '../../../../components/list/TableComponentsStyled';
import AuthorizationsListResponsiveTableRowCell from './AuthorizationListResponsiveTableRowCell';
import AuthorizationListActionCell from './AuthorizationListActionCell';

const AuthorizationListResponsiveTableRow = props => {
  const { userGroups, authorization, index, dispatch, onRefineAuthorization, onUnrefineAuthorization, authorizationChangedPermissions } =
    props;

  return (
    <TableRow hover>
      <TableCellStickyColumn>
        <Tooltip title={authorization.description}>{authorization.name}</Tooltip>
      </TableCellStickyColumn>
      <AuthorizationListActionCell
        authorization={authorization}
        dispatch={dispatch}
        userGroups={userGroups}
        index={index}
        onRefineAuthorization={onRefineAuthorization}
        onUnrefineAuthorization={onUnrefineAuthorization}
      />
      {userGroups?.map(userGroup => (
        <AuthorizationsListResponsiveTableRowCell
          key={userGroup.id}
          userGroup={userGroup}
          authorization={authorization}
          dispatch={dispatch}
          changedPermission={authorizationChangedPermissions[userGroup.id]}
        />
      ))}
    </TableRow>
  );
};

AuthorizationListResponsiveTableRow.propTypes = {
  authorizationChangedPermissions: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
  authorization: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  onRefineAuthorization: PropTypes.func.isRequired,
  onUnrefineAuthorization: PropTypes.func.isRequired
};

export default AuthorizationListResponsiveTableRow;
